import { render, staticRenderFns } from "./custOrder.vue?vue&type=template&id=866497be&scoped=true&"
import script from "./custOrder.vue?vue&type=script&lang=js&"
export * from "./custOrder.vue?vue&type=script&lang=js&"
import style0 from "./custOrder.vue?vue&type=style&index=0&id=866497be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866497be",
  null
  
)

export default component.exports